import { Component } from '@angular/core';
import {CardModule} from "primeng/card";
import {ButtonDirective} from "primeng/button";
import {RouterLink} from "@angular/router";
import {IconComponent} from "../layout/icon/icon.component";

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    CardModule,
    ButtonDirective,
    RouterLink,
    IconComponent
  ],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
